import postImageAreaView from './postImageAreaComponent.html';
import VideoPlayer from 'components/sharpr/videoPlayer/VideoPlayer';
import './postImageAreaComponent.css';

export function postImageAreaComponent() {
	return {
		restrict: 'E',
		bindings: {
			post: '=',
			geometry: '<',
			linkTo: '@',
			allowEnlarge: '<?',
			isMinimal: '<?',
		},
		controllerAs: 'vm',
		template: postImageAreaView,
		controller: postImageAreaComponentCtrl,
	};
}

class postImageAreaComponentCtrl {
	constructor(Theme) {
		'ngInject';
		this.Theme = Theme;
	}

	isArticle() {
		return !this.isVideo() && !this.isSlideshow();
	}

	isSlideshow() {
		return this.post.attachment_thumbnails && this.post.attachment_thumbnails.length;
	}

	isPreviewable() {
		return this.post.attachment_icon_classes && this.post.attachment_icon_classes.length > 0;
	}

	isImgOrVideo() {
		return !this.isSlideshow();
	}

	showAttPreviewLinks() {
		return this.isPreviewable() && !this.isSlideshow() && !this.isMinimal;
	}

	showAttPreview() {
		return this.post.pending_attachment_count > 0 && !this.isMinimal;
	}

	isVideo() {
		return !!VideoPlayer.getPlayableUrl(this.post);
	}

	getIconType() {
		let type = 'article';

		if (this.isVideo()) {
			type = 'video';
		} else if (this.isPreviewable()) {
			type = 'preview-files';
		}

		return type;
	}

	hasMultiPreviews() {
		return this.isPreviewable() && this.post.attachment_icon_classes.length > 1;
	}

	hasMissingImage() {
		let url = '';
		try {
			url = this.post.image.url;
		} catch (e) {
			return false;
		}

		if (url === undefined) {
			return false;
		}

		let missingImageUrl = this.Theme.img('missing.png');
		return missingImageUrl == this.post.image.url;
	}

	getFileCount() {
		if (!this.hasMultiPreviews()) {
			return 0;
		}

		return this.post.attachment_icon_classes.length;
	}
}
